module.exports = __webpack_public_path__ + "img/dica1.add5c541.jpeg";